import {bar} from '../../components/scheduleBar/scheduleBar.js';
import {documentLocale} from '../../localization/documentLocale.js';
import {hideOverFooter} from '../../modules/hideOverFooter.js';

/**
 * Display Localized Time As Tooltip for elements with .js-timestampToToolTip class
 */
function displayLocalizedTimeAsTooltip() {
    const formats = {
        datetime: {
            weekday: 'short',
            month: 'long',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h24',
        },
        time: {
            hour: '2-digit',
            minute: '2-digit',
            timeZoneName: 'long',
            hourCycle: 'h12',
        },
    };

    [...document.querySelectorAll('.js-timestampToToolTip')].forEach(
        /** @param {HTMLElement} element */
        (element) => {
            const timestamp = element.dataset.timestamp;
            if (!timestamp) {
                return;
            }
            const format = element.dataset.format || 'datetime';
            const options = formats[format];
            const date = new Date(Number(timestamp) * 1000);
            const localTime = date.toLocaleString(undefined, options);
            element.textContent = localTime;
            element.dataset.title = date.toLocaleString(documentLocale(), {...options, timeZone: 'UTC'});
        }
    );
}

/** Shows the footer schedule bar once the top schedule bar scrolls out of view. */
function handleMasterclassScheduleStickyFooter() {
    const topScheduleBar = document.querySelector('.js-masterclassScheduleBar');
    const footerScheduleBarWrapper = document.querySelector('.js-masterclassFooterScheduleBarWrapper');
    const siteFooter = document.querySelector('.js-siteFooter');

    if (!(footerScheduleBarWrapper instanceof HTMLElement) || !topScheduleBar || !(siteFooter instanceof HTMLElement)) return;

    new IntersectionObserver((entries) => {
        footerScheduleBarWrapper.classList.toggle('translate-y-full', entries.at(-1).intersectionRatio > 0);
    }).observe(topScheduleBar);
    hideOverFooter(footerScheduleBarWrapper, siteFooter);
}

/** Initialize the page */
function initPage() {
    bar.runCountdowns();
    handleMasterclassScheduleStickyFooter();
    displayLocalizedTimeAsTooltip();
}

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initPage) : initPage();
